export default "__VITE_ASSET__5f629599__"